// forked from https://github.com/wix-private/docs/blob/master/packages/docs-web-app/src/hooks/useCopyCode.tsx
import type React from 'react';
import { useEffect, useRef, useState } from 'react';

interface useCopyCodeResult {
  copy: () => void;
  message: React.ReactNode;
}

export default function useCopy(
  labelDo: string,
  labelDone: string,
  content: string
): useCopyCodeResult {
  const [message, setMessage] = useState<React.ReactNode>(labelDo);

  const timeoutRef = useRef<any>(null);

  useEffect(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setMessage(labelDo);
    }, 2000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [message]);

  return { copy, message };

  function copy() {
    return copyToClipboard(content).then(() => {
      setMessage(labelDone);
    });
  }
}

export function copyToClipboard(content: string): Promise<void> {
  return navigator.clipboard.writeText(content).catch(() => {
    deprecatedCopyToClipboard(content);
  });
}

function deprecatedCopyToClipboard(code: string) {
  const el = document.createElement('textarea');
  el.value = code;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand && document.execCommand('copy');
  document.body.removeChild(el);
}
